import React, { useState, useEffect, useContext } from "react";
import BqnContext from "common/BqnContext";
import Request from "common/Request";
import Result from "./Result";
import {
  parsePoolMemoryUsage,
  parseDPDKMemoryUsage,
  parseSystemMemoryCluster,
} from "./api.js";
import ActionsContext from "common/ActionsContext";
import View from "common/View";
import useDebouncer from "common/hooks/debouncer";

const LOAD_INTERVAL = 3000;

export const memoryUsageRetrieval = (mode) =>
  Promise.all([
    ifCl.run("show system memory").then((response)=>parseSystemMemoryCluster(response, mode)),
    ifCl.run("show pkteng memory").then((response)=>parsePoolMemoryUsage(response, mode)),
    ifCl.run("show pkteng memory dpdk").then((response)=>parseDPDKMemoryUsage(response, mode)),
  ]).then(([System, Mpool, Dpdk]) => ({ System, Mpool, Dpdk }));

const Report = () => {
  const {clusterStatus: {mode}} = useContext(BqnContext);
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const [liveData, setLiveData] = useState(null);

  const debounce = useDebouncer(500 /*ms*/);

  useEffect(() => {
    let active = true;

    const doLoad = () => {
      const req = memoryUsageRetrieval(mode).then((data) => {
        if (active) setLiveData(data);
        return data;
      });
      setRequest(req);
    };

    const doBackgroundLoad = () => {
      memoryUsageRetrieval(mode)
        .then((data) => {
          if (active) setLiveData(data);
        })
        .catch((err) => console.error("Memory background fetch failed:", err));
    };

    doLoad();
    const intervalId = setInterval(doBackgroundLoad, LOAD_INTERVAL);
    const unsubscribe = actions.recv("do-load", () => debounce(doLoad));

    return () => {
      active = false;
      clearInterval(intervalId);
      unsubscribe();
      debounce.stop();
    };
  }, [mode, debounce]);

  return (
    <Request during={request}>
      {() => (liveData ? <Result {...liveData} /> : null)}
    </Request>
  );
};

const MemoryStatus = () => (
  <View title="Memory Usage">
    <Report />
  </View>
) 
export default MemoryStatus;
